import { StyleSheet } from 'react-native';

export default StyleSheet.create({
   row: {
        display: 'flex',
        alignItems: 'center',
        padding: 20,
        width: '100%'
    },
});
